
import React from "react";

interface InstagramPreviewProps {
  thumbnailUrl: string;
  instagramUrl: string;
}

const InstagramPreview: React.FC<InstagramPreviewProps> = ({
  thumbnailUrl,
  instagramUrl
}) => {
  return (
    <div className="instagram-preview w-full max-w-[400px] mx-auto">
      <a 
        href={instagramUrl} 
        target="_blank" 
        rel="noopener noreferrer"
        className="block rounded-xl overflow-hidden border border-neutral-200 shadow-sm hover:opacity-95 transition-opacity"
      >
        <img 
          src={thumbnailUrl} 
          alt="Instagram post" 
          className="w-full object-cover rounded-xl" 
        />
      </a>
    </div>
  );
};

export default InstagramPreview;
